import _defineProperty from "babel-runtime/helpers/defineProperty";


var Textinput = {
  name: "kui-textinput",
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      value: "",
      isPassValidate: true };
  },
  computed: {
    titleName: function titleName() {
      return this.options.title ? this.options.title + ":" : "";
    },
    placeholder: function placeholder() {
      return this.options.required && !this.disabled ? "必填" : "";
    },
    disabled: function disabled() {
      return this.options.disabled || false;
    }
  },
  methods: {
    textinput: function textinput(opts) {
      var _this = this;

      if (_.isString(opts)) {
        if ((arguments.length <= 1 ? 0 : arguments.length - 1) > 1) {
          this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
        } else {
          this[opts].call(this, arguments.length <= 1 ? undefined : arguments[1]);
        }
      } else {
        _.assign(this.options, opts);
        _.each(this.options, function (v, k) {
          if (!_.isFunction(v) && k == "val") {
            _this.setValue(v);
          }
        });
      }
    },
    onButtonClick: function onButtonClick() {
      if (this.options.onButtonClick) {
        this.options.onButtonClick(this);
      }
    },
    valChange: function valChange(value) {
      if (this.options.onChange) {
        this.options.onChange.call(this, value);
      }
    },
    hideTips: function hideTips() {
      this.isPassValidate = true;
      this.$refs.validatebox.hideTips();
    },
    validate: function validate() {
      this.isPassValidate = this.$refs.validatebox.validate(this.value);
      return this.isPassValidate;
    },

    getValue: function getValue() {
      return this.value;
    },
    setValue: function setValue(value) {
      this.value = value;
    },
    setEnabled: function setEnabled() {
      this.disabled = false;
    },
    setDisabled: function setDisabled() {
      this.disabled = true;
    },
    clear: function clear() {
      this.value = "";
    },
    getData: function getData() {
      return _defineProperty({}, this.options.field, this.value);
    }
  }
};

export default Textinput;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/textinput/src/textinput.js
// module id = 1470
// module chunks = 2